import { useEffect, useState } from 'react';

/**
 * Breakpoints supported in our application.
 */
export enum Breakpoints {
  /** Mobile devices, small browsers */
  MOBILE = 768,
  /** Small browsers. */
  SMALL = 1024,
  /** medium sized browsers */
  MEDIUM = 1200,
  /** Large browsers, but not quite 1080p */
  LARGE = 1600
}

/**
 * Copied from react-laag
 *
 * MIT License
 * Copyright (c) 2019 Erik Verweij
 *
 */
function useBreakpointInternal(maxPixels: number): boolean {
  const [match, setMatch] = useState(
    typeof window !== 'undefined'
      ? window.matchMedia('(max-width: ' + maxPixels + 'px)').matches
      : false
  );
  useEffect(() => {
    const matcher = window.matchMedia('(max-width: ' + maxPixels + 'px)');

    function onMatch(evt: MediaQueryListEvent) {
      setMatch(evt.matches);
    }

    matcher.addEventListener('change', onMatch);
    return () => {
      matcher.removeEventListener('change', onMatch);
    };
  }, [maxPixels]);
  return match;
}

/**
 *
 */
export function useBreakpoint(bp: Breakpoints): boolean {
  return useBreakpointInternal(bp);
}
